import { render, staticRenderFns } from "./DateTab.vue?vue&type=template&id=64901bf0&scoped=true"
import script from "./DateTab.vue?vue&type=script&lang=js"
export * from "./DateTab.vue?vue&type=script&lang=js"
import style0 from "./DateTab.vue?vue&type=style&index=0&id=64901bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64901bf0",
  null
  
)

export default component.exports